import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import WhySpecialized from './components/WhySpecialized';
import ServicesSection from './components/ServicesSection';
import WhoWeServe from './components/WhoWeServe';
import ApproachSection from './components/ApproachSection';
import AreasServed from './components/AreasServed';
import FAQSection from './components/FAQSection';
import LeadCapture from './components/LeadCapture';
import BlogTeaser from './components/BlogTeaser';
import FinalCTA from './components/FinalCTA';

const bookkeepingSecondaryNav = {
  links: [
    { label: 'Services', href: '#services' },
    { label: 'Industries', href: '#industries' },
    { label: 'Areas Served', href: '#areas' },
    { label: 'About', href: '#approach' },
    { label: 'Resources', href: '#resources' },
  ],
  cta: { label: 'Book Free Discovery Call', href: '#contact' },
};

export default function Bookkeeping() {
  return (
    <main className="min-h-screen">
      <SiteHeader secondary={bookkeepingSecondaryNav} />
      <HeroSection />
      <TrustBar />
      <WhySpecialized />
      <ServicesSection />
      <WhoWeServe />
      <ApproachSection />
      <AreasServed />
      <FAQSection />
      <LeadCapture />
      <BlogTeaser />
      <FinalCTA />
      <SiteFooter variant="bookkeeping" />
    </main>
  );
}